/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsTeamBanRateDtoSchema } from "./teamBanRateDtoSchema.ts";
import { goodLuckCoreDTOsTeamChampionStatsDtoSchema } from "./teamChampionStatsDtoSchema.ts";
import { goodLuckCoreDTOsTeamObjectivesDtoSchema } from "./teamObjectivesDtoSchema.ts";
import { goodLuckCoreDTOsTeamPlayerStatsDtoSchema } from "./teamPlayerStatsDtoSchema.ts";
import { goodLuckCoreDTOsTeamRecordsDtoSchema } from "./teamRecordsDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamExtendedStatsDtoSchema = z.object({
  blueGames: z.optional(z.int()),
  blueWins: z.optional(z.int()),
  redGames: z.optional(z.int()),
  redWins: z.optional(z.int()),
  get records() {
    return goodLuckCoreDTOsTeamRecordsDtoSchema.optional();
  },
  get bansAgainst() {
    return z.array(goodLuckCoreDTOsTeamBanRateDtoSchema).nullish();
  },
  get bansByTeam() {
    return z.array(goodLuckCoreDTOsTeamBanRateDtoSchema).nullish();
  },
  get objectives() {
    return goodLuckCoreDTOsTeamObjectivesDtoSchema.optional();
  },
  avgCsDiffAt15: z.optional(z.number()),
  avgGoldDiffAt15: z.optional(z.number()),
  avgXpDiffAt15: z.optional(z.number()),
  avgKillAssistDiffAt15: z.optional(z.number()),
  killParticipation: z.optional(z.number()),
  firstBloodRate: z.optional(z.number()),
  firstTowerRate: z.optional(z.number()),
  get championStats() {
    return z.array(goodLuckCoreDTOsTeamChampionStatsDtoSchema).nullish();
  },
  get playerStats() {
    return z.array(goodLuckCoreDTOsTeamPlayerStatsDtoSchema).nullish();
  },
});
